import { FC } from "react";

import Select from "../../../../components/Select";
import Text from "../../../../components/Text";
import styles from "./styles.module.scss";

type FilterFieldProps = {
    label: string;
    options: Array<{ label: string; value: string }>;
    value: string | undefined;
    onChange: (value: string) => void;
    isMultiple?: boolean;
};

const FilterField: FC<FilterFieldProps> = ({
    label,
    options,
    value,
    onChange,
    isMultiple = false,
}) => {
    return (
        <div className={styles.selectContainer}>
            <Text variant="body-bold">{label}</Text>
            <Select
                type={isMultiple ? "multiple" : undefined}
                options={options}
                value={value}
                onChange={(selectedValue) => onChange(selectedValue as string)}
            />
        </div>
    );
};

export default FilterField;
